export const paragraphs = [
  {
    id: 1,
    content:
      "My journey into tech started when I tried to impress my friends by creating a basic website—only to realize I had no idea what I was doing. That led me to Python in high school, but it didn't quite click. Then, during the COVID-19 pandemic, I switched gears to JavaScript, HTML, and CSS. I built my first project, a mood-tracking app, which actually worked—surprisingly!",
  },
  {
    id: 2,
    content:
      "I got hooked and moved on to React, though I spent way too much time watching tutorials without actually building anything. But then I had a breakthrough: I built a COVID-19 tracker that people actually used. That was the moment I knew I was onto something.",
  },
  {
    id: 3,
    content:
      "From there, I built a few beginner-friendly projects, some of them were actually exciting. Along the way, I picked up some freelance gigs, worked as a contractor, overall built more than ten apps and eventually landed my first job as a frontend developer.",
  },
  {
    id: 4,
    content:
      "These days, I lead a ten-engineer frontend team at Appinventiv, rebuilding Whataburger's web app with Next.js, and I'm building a bookmark manager on the side. I believe that passion, curiosity, and plenty of coffee can take you further than a formal degree ever could.",
  },
];
